import { FileUploadData, SelectOption } from "@pulseops/common"

export namespace CSProcessGuidelineDocForm {
  export interface CSProcessGuidelineCreatingDocInfo {
    documentType: SelectOption | undefined
    documentTypeDetail: SelectOption | undefined
    uploadFiles: FileUploadData[]
    errorMessage: string
    keyID: string
    effectiveDate: Date | null
  }

  export interface CSProcessGuidelineCreatingDocData {
    newGuidelinelist: Array<CSProcessGuidelineCreatingDocInfo>
  }

  export interface CSProcessGuidelineDocListData {
    from: Date | null
    to: Date | null
    docID: SelectOption | undefined
    isSelectedAll: boolean
    guidelineDoclist: Array<CSProcessGuidelineDocDataInfo>
    documentTypeDetail: SelectOption | undefined
  }

  export type CSProcessGuidelineDocDataInfo = {
    historyID: string
    isSelectedItem: boolean
  }
}